import { useSelector } from 'react-redux'
import currencyConversionIcon from '../../../../common/icons/currencyConversion.svg'
import { Image } from '../../../../common/image'
import { Tooltip } from '../../../../common/tooltip'
import { formatCurrencyFollowLocale } from '../../../../helpers/value'
import { CURRENCY } from '../../../../utils/currency'

export const PriceConversion = ({ value }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Tooltip
      contentClass="wFitContent dFlex ml1"
      contentStyle={{ marginTop: 3 }}
      tooltipContent={formatCurrencyFollowLocale(value, CURRENCY.USD, locale)}
    >
      <Image
        src={currencyConversionIcon}
        alt="currency conversion"
        style={{ width: 13, height: 13 }}
      />
    </Tooltip>
  )
}
